// @generated by protoc-gen-es v2.10.1 with parameter "target=ts,import_extension=none"
// @generated from file monitoring/v1/monitoring.proto (package monitoring.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ARPEntry, FDBEntry, Interface } from "../../poller/v1/poller_pb";
import { file_poller_v1_poller } from "../../poller/v1/poller_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file monitoring/v1/monitoring.proto.
 */
export const file_monitoring_v1_monitoring: GenFile = /*@__PURE__*/
  fileDesc("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", [file_poller_v1_poller]);

/**
 * @generated from message monitoring.v1.GetSystemStatusRequest
 */
export type GetSystemStatusRequest = Message<"monitoring.v1.GetSystemStatusRequest"> & {
};

/**
 * Describes the message monitoring.v1.GetSystemStatusRequest.
 * Use `create(GetSystemStatusRequestSchema)` to create a new message.
 */
export const GetSystemStatusRequestSchema: GenMessage<GetSystemStatusRequest> = /*@__PURE__*/
  messageDesc(file_monitoring_v1_monitoring, 0);

/**
 * @generated from message monitoring.v1.GetSystemStatusResponse
 */
export type GetSystemStatusResponse = Message<"monitoring.v1.GetSystemStatusResponse"> & {
  /**
   * @generated from field: string status = 1;
   */
  status: string;

  /**
   * @generated from field: int64 uptime = 2;
   */
  uptime: bigint;

  /**
   * @generated from field: string version = 3;
   */
  version: string;

  /**
   * @generated from field: double cpu_usage = 4;
   */
  cpuUsage: number;

  /**
   * @generated from field: double ram_usage = 5;
   */
  ramUsage: number;

  /**
   * @generated from field: string redis_status = 6;
   */
  redisStatus: string;

  /**
   * @generated from field: string db_status = 7;
   */
  dbStatus: string;

  /**
   * @generated from field: int32 db_open_connections = 8;
   */
  dbOpenConnections: number;

  /**
   * @generated from field: int32 db_in_use_connections = 9;
   */
  dbInUseConnections: number;

  /**
   * @generated from field: int32 db_idle_connections = 10;
   */
  dbIdleConnections: number;

  /**
   * @generated from field: int64 last_update = 11;
   */
  lastUpdate: bigint;
};

/**
 * Describes the message monitoring.v1.GetSystemStatusResponse.
 * Use `create(GetSystemStatusResponseSchema)` to create a new message.
 */
export const GetSystemStatusResponseSchema: GenMessage<GetSystemStatusResponse> = /*@__PURE__*/
  messageDesc(file_monitoring_v1_monitoring, 1);

/**
 * @generated from message monitoring.v1.StreamInterfacesRequest
 */
export type StreamInterfacesRequest = Message<"monitoring.v1.StreamInterfacesRequest"> & {
  /**
   * @generated from field: int64 device_id = 1;
   */
  deviceId: bigint;
};

/**
 * Describes the message monitoring.v1.StreamInterfacesRequest.
 * Use `create(StreamInterfacesRequestSchema)` to create a new message.
 */
export const StreamInterfacesRequestSchema: GenMessage<StreamInterfacesRequest> = /*@__PURE__*/
  messageDesc(file_monitoring_v1_monitoring, 2);

/**
 * @generated from message monitoring.v1.InterfaceStreamUpdate
 */
export type InterfaceStreamUpdate = Message<"monitoring.v1.InterfaceStreamUpdate"> & {
  /**
   * @generated from field: repeated poller.v1.Interface interfaces = 1;
   */
  interfaces: Interface[];

  /**
   * @generated from field: string stage = 2;
   */
  stage: string;

  /**
   * @generated from field: bool is_delta = 3;
   */
  isDelta: boolean;

  /**
   * @generated from field: string source = 4;
   */
  source: string;

  /**
   * @generated from field: string poll_type = 5;
   */
  pollType: string;

  /**
   * @generated from field: int64 timestamp = 6;
   */
  timestamp: bigint;

  /**
   * @generated from field: string error = 7;
   */
  error: string;

  /**
   * @generated from field: string snmp_method = 8;
   */
  snmpMethod: string;

  /**
   * IFErr measurement is independent from the stream stage. Old empty value is unknown.
   *
   * @generated from field: string interface_errors_status = 9;
   */
  interfaceErrorsStatus: string;

  /**
   * @generated from field: string interface_discards_status = 10;
   */
  interfaceDiscardsStatus: string;
};

/**
 * Describes the message monitoring.v1.InterfaceStreamUpdate.
 * Use `create(InterfaceStreamUpdateSchema)` to create a new message.
 */
export const InterfaceStreamUpdateSchema: GenMessage<InterfaceStreamUpdate> = /*@__PURE__*/
  messageDesc(file_monitoring_v1_monitoring, 3);

/**
 * @generated from message monitoring.v1.GetDeviceFDBRequest
 */
export type GetDeviceFDBRequest = Message<"monitoring.v1.GetDeviceFDBRequest"> & {
  /**
   * @generated from field: int64 device_id = 1;
   */
  deviceId: bigint;

  /**
   * @generated from field: int32 page = 2;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;

  /**
   * @generated from field: string mac_filter = 4;
   */
  macFilter: string;

  /**
   * @generated from field: int32 vlan_filter = 5;
   */
  vlanFilter: number;

  /**
   * Interface name or bridge port; trailing * selects an interface-name prefix.
   *
   * @generated from field: string port_filter = 6;
   */
  portFilter: string;

  /**
   * @generated from field: string type_filter = 7;
   */
  typeFilter: string;

  /**
   * @generated from field: string search_filter = 8;
   */
  searchFilter: string;

  /**
   * Allowlist: vlan_id, port (interface name), mac_address.
   *
   * @generated from field: string sort_by = 9;
   */
  sortBy: string;

  /**
   * @generated from field: bool sort_desc = 10;
   */
  sortDesc: boolean;

  /**
   * Direct snapshot has no age history: only duplicates/any are meaningful.
   *
   * @generated from field: string problem_filter = 11;
   */
  problemFilter: string;
};

/**
 * Describes the message monitoring.v1.GetDeviceFDBRequest.
 * Use `create(GetDeviceFDBRequestSchema)` to create a new message.
 */
export const GetDeviceFDBRequestSchema: GenMessage<GetDeviceFDBRequest> = /*@__PURE__*/
  messageDesc(file_monitoring_v1_monitoring, 4);

/**
 * @generated from message monitoring.v1.GetDeviceFDBResponse
 */
export type GetDeviceFDBResponse = Message<"monitoring.v1.GetDeviceFDBResponse"> & {
  /**
   * @generated from field: repeated poller.v1.FDBEntry entries = 1;
   */
  entries: FDBEntry[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;

  /**
   * @generated from field: int32 total_pages = 3;
   */
  totalPages: number;

  /**
   * @generated from field: int32 duplicate_count = 4;
   */
  duplicateCount: number;
};

/**
 * Describes the message monitoring.v1.GetDeviceFDBResponse.
 * Use `create(GetDeviceFDBResponseSchema)` to create a new message.
 */
export const GetDeviceFDBResponseSchema: GenMessage<GetDeviceFDBResponse> = /*@__PURE__*/
  messageDesc(file_monitoring_v1_monitoring, 5);

/**
 * @generated from message monitoring.v1.GetDeviceARPRequest
 */
export type GetDeviceARPRequest = Message<"monitoring.v1.GetDeviceARPRequest"> & {
  /**
   * @generated from field: int64 device_id = 1;
   */
  deviceId: bigint;

  /**
   * @generated from field: int32 page = 2;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;

  /**
   * @generated from field: string ip_filter = 4;
   */
  ipFilter: string;

  /**
   * @generated from field: string mac_filter = 5;
   */
  macFilter: string;

  /**
   * @generated from field: int32 vlan_filter = 6;
   */
  vlanFilter: number;
};

/**
 * Describes the message monitoring.v1.GetDeviceARPRequest.
 * Use `create(GetDeviceARPRequestSchema)` to create a new message.
 */
export const GetDeviceARPRequestSchema: GenMessage<GetDeviceARPRequest> = /*@__PURE__*/
  messageDesc(file_monitoring_v1_monitoring, 6);

/**
 * @generated from message monitoring.v1.GetDeviceARPResponse
 */
export type GetDeviceARPResponse = Message<"monitoring.v1.GetDeviceARPResponse"> & {
  /**
   * @generated from field: repeated poller.v1.ARPEntry entries = 1;
   */
  entries: ARPEntry[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;

  /**
   * @generated from field: int32 total_pages = 3;
   */
  totalPages: number;
};

/**
 * Describes the message monitoring.v1.GetDeviceARPResponse.
 * Use `create(GetDeviceARPResponseSchema)` to create a new message.
 */
export const GetDeviceARPResponseSchema: GenMessage<GetDeviceARPResponse> = /*@__PURE__*/
  messageDesc(file_monitoring_v1_monitoring, 7);

/**
 * DeviceMonitoringService отвечает за мониторинг конкретных устройств (коммутаторы, OLT и т.д.)
 *
 * @generated from service monitoring.v1.DeviceMonitoringService
 */
export const DeviceMonitoringService: GenService<{
  /**
   * Потоковая передача интерфейсов (замена SSE)
   *
   * @generated from rpc monitoring.v1.DeviceMonitoringService.StreamInterfaces
   */
  streamInterfaces: {
    methodKind: "server_streaming";
    input: typeof StreamInterfacesRequestSchema;
    output: typeof InterfaceStreamUpdateSchema;
  },
  /**
   * Получение FDB таблицы (Unary)
   *
   * @generated from rpc monitoring.v1.DeviceMonitoringService.GetDeviceFDB
   */
  getDeviceFDB: {
    methodKind: "unary";
    input: typeof GetDeviceFDBRequestSchema;
    output: typeof GetDeviceFDBResponseSchema;
  },
  /**
   * Получение ARP таблицы (Unary)
   *
   * @generated from rpc monitoring.v1.DeviceMonitoringService.GetDeviceARP
   */
  getDeviceARP: {
    methodKind: "unary";
    input: typeof GetDeviceARPRequestSchema;
    output: typeof GetDeviceARPResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_monitoring_v1_monitoring, 0);

/**
 * InfrastructureMonitoringService отвечает за мониторинг состояния серверов, очередей и БД
 *
 * @generated from service monitoring.v1.InfrastructureMonitoringService
 */
export const InfrastructureMonitoringService: GenService<{
  /**
   * Получение общего статуса инфраструктуры
   *
   * @generated from rpc monitoring.v1.InfrastructureMonitoringService.GetSystemStatus
   */
  getSystemStatus: {
    methodKind: "unary";
    input: typeof GetSystemStatusRequestSchema;
    output: typeof GetSystemStatusResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_monitoring_v1_monitoring, 1);

